<div #dropdownEl
  class="ui-dropdown"
  [class.is-open]="isOpen"
  [class.ui-dropdown--inline]="inline"
  [class.ui-dropdown--align-right]="alignRight">
  <ng-content></ng-content>
</div>
